var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "6" } },
        [
          _c("w-select", {
            attrs: {
              label: _vm.$ct("default-report-type"),
              fancy: "",
              items: _vm.reportTypeItems,
            },
            model: {
              value: _vm.value.DefaultType,
              callback: function ($$v) {
                _vm.$set(_vm.value, "DefaultType", $$v)
              },
              expression: "value.DefaultType",
            },
          }),
        ],
        1
      ),
      _vm.isSupportSession
        ? _c(
            "w-col",
            { attrs: { xs: "12" } },
            [
              _c("w-input", {
                attrs: {
                  value: _vm.manualPreloadString,
                  label: _vm.$ct("manual-preloads"),
                  fancy: "",
                },
                on: {
                  input: function ($event) {
                    return _vm.setManualPreloads($event)
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _c(
        "w-col",
        { attrs: { xs: "12" } },
        [
          _c("w-checkbox", {
            attrs: {
              value: !_vm.value.DontRequireBookYearSelection,
              label: _vm.$ct("bookyear-filter-required"),
            },
            on: {
              input: function ($event) {
                return _vm.setDontRequireBookYearSelection($event)
              },
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }